<template>

    <div class="my-6">

        <div class="my-3">
            <ListBoxSelectWithImage :options="type3DMaterial" v-model="form.type3Dprinting" placeholder="Select Option"
                labelMain="Material Type" class="my-3" requires="True" />

            <div v-if="form.type3Dprinting == 'Other'">
                <BaseTextArea
                    label="Please tell us about the material you require. We can source material as a non-stock request, for additional leadtime and cost."
                    v-model="form.type3DprintingOther"
                    tooltip="We can source different material as a non-stock request, for additional leadtime and cost." />

            </div>

            <ListBoxSelectWithImage :options="colorFilament" v-model="form.colorFilament" placeholder="Select Option"
                labelMain=" What color filament do you require?" class="my-3" requires="True" />

            <!-- other type of color filament -->
            <div v-if="form.colorFilament == 'Other'">
                <BaseInput label="Please specify the color of the filament" v-model="form.otherColorFilament" />
            </div>

            <Alert
                message='*We currently stock black-colored filament. If you require something other than black, we are happy to order additional filament colors for additional lead time and cost.'
                class="my-3" />


            <BaseInput label="What percentage infill do you require?" class="my-3" v-model="form.infillPercentage" />

            <Alert message='The density of the infill can range in 5% increments from 0-100%. The standard infill percentage
            is 15%.' class="my-3" />

            <ListBoxSelectWithImage :options="layerHeight" v-model="form.layerHeight" placeholder="Select Option"
                labelMain="What Layer Height do you require?" class="my-3" />

            <!-- if layerHeight is other -->
            <div v-if="form.layerHeight == 'Other'">
                <BaseInput label="Please specify the layer height" v-model="form.otherLayerHeight" />
            </div>

            <ListBoxSelectWithImage :options="surfaceFinish" v-model="form.surfaceFinish" placeholder="Select Option"
                labelMain="We offer rectilinear surface finish as a standard finish for 3D Printing. Will you require a different surface finish? (Note: There may be additional leadtime required.)"
                class="my-3" />
        </div>

    </div>

</template>

<script setup>
import { inject } from 'vue';

import {
    type3DMaterial, colorFilament, layerHeight, surfaceFinish
} from '../../constants/threeDprinting';
import Alert from '../formComponents/Alert.vue';
import BaseInput from '../formComponents/BaseInput.vue';
import BaseTextArea from '../formComponents/BaseTextArea.vue';

import ListBoxSelectWithImage from '../formComponents/ListBoxSelectWithImage.vue';


const form = inject('form');

</script>